import Redis from 'ioredis';

export const createRedisClient = (options = defaultOptions) => {
  const redis = new Redis(options);

  return redis;
};

let redis;

const defaultOptions = {
  host: process.env.REDIS_HOST || '', // Redis host
  port: +process.env.REDIS_PORT! || 6379, // Redis port
  password: process.env.REDIS_PASSWORD,
  db: +process.env.REDIS_DB! || 1
}

export const getRedisClient = async (options = defaultOptions) => {
  if (!redis) {
    redis = await createRedisClient(options);
  }
  return redis;
};
